import DeviceGroup from "@/classes/DeviceGroup";
import { StateInterface } from "./state";
import { GlobalInterface } from "../index.js";
import { GetterTree } from "vuex";
import Device from "@/classes/Device";

const getters: GetterTree<StateInterface, GlobalInterface> = {
  /**
   * @returns array containing device groups
   * @see DeviceGroup class
   */
  allDeviceGroups: (state) => {
    return state.deviceGroups;
  },
  /**
   * filter devices by a search term within one group
   * @param searchQuery name of device to search for
   * @param groupId id of the current active device group
   * @returns list of devices wich mach
   */
  filterDevices: (state) => (groupId: number, searchQuery: string) => {
    const group = state.deviceGroups.find((group) => group.GID === groupId);
    if (!group) {
      return [];
    }

    return group.devices.filter(function(device) {
      let regex = new RegExp("(" + searchQuery + ")", "i");

      if (!device.NAME) {
        return device;
      } else {
        return device.NAME.match(regex);
      }
    });
  },
  devicesForIds: (state) => (ids: number[]) => {
    const devices: Device[] = [];
    state.deviceGroups.forEach((group) => {
      group.devices.forEach((dev) => {
        if (ids.includes(dev.DID) && !devices.includes(dev)) {
          devices.push(dev);
        }
      });
    });

    return devices;
  },
  /**
   * @returns array of all device groups formatted as select options (for quasar select)
   */
  allDeviceGroupSelectOptions: (state) => {
    const groupList: { label: string; value: DeviceGroup }[] = [];
    state.deviceGroups.forEach((group) => {
      groupList.push({ label: group.GNAME, value: group });
    });

    return groupList;
  },
  /**
   * @returns group of given device id or null if not found
   */
  groupForDeviceId: (state) => (deviceId: number) => {
    let respGroup = null;
    for (let i = 0; i < state.deviceGroups.length; i++) {
      const group = state.deviceGroups[i];
      group.devices.find((dev) => dev.DID === deviceId);
      respGroup = group;
      break;
    }
    return respGroup;
  },
};

export default getters;
